import classNames from 'classnames';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

import useLayout from '@/hooks/useLayout';
import useParam from '@/hooks/useParam';

import Back from '../back';
import { ReactComponent as MenuIconDeposit } from './assets/menu_icon_deposit.svg';
import { ReactComponent as MenuIconRecord } from './assets/menu_icon_records.svg';
import { ReactComponent as MenuIconVip } from './assets/menu_icon_vip.svg';
import { ReactComponent as MenuIconWithdraw } from './assets/menu_icon_withdraw.svg';
import styles from './styles.module.less';

const AmountMenu = () => {
  const { type, from } = useParam<{ type?: number; from?: string }>();
  const isGameing = !!(type && +type === 1);
  const isNeedBack = !!(type && +type === 2);
  const isFromWithdrawTask = from && from === 'withdraw_task';
  const location = useLocation();
  const getRecordLink = () => {
    const link = sessionStorage.getItem('last__record__menu');
    return {
      pathname: link || '/recharge/record',
      search: location.search
    };
  };

  const navigate = useNavigate();

  const backMap = {
    my: <Back onClick={() => navigate('/my', { replace: true })} />
  };
  useLayout({
    headers: {
      left: isNeedBack ? (
        <Back />
      ) : isGameing ? (
        <Back onClick={() => navigate('/play')} />
      ) : from ? (
        backMap[from]
      ) : null,
      right: null
    },
    hideNavBar: isFromWithdrawTask || isGameing || false,
    hideHeader: !(from || type)
  });
  if (isGameing) {
    return <Outlet />;
  }
  if (isFromWithdrawTask) {
    return (
      <>
        <div className={styles.back}>
          <Back onClick={() => navigate('/game?open=withdraw_task', { replace: true })} />
        </div>
        <Outlet />
      </>
    );
  }
  return (
    <>
      <div className={styles.menu}>
        <Link
          className={classNames(styles.item, {
            [styles.active]: location.pathname === '/recharge'
          })}
          replace
          to={{ pathname: '/recharge', search: location.search }}
        >
          <MenuIconDeposit />
          <div>Deposit</div>
        </Link>
        <Link
          className={classNames(styles.item, {
            [styles.active]: location.pathname === '/withdraw'
          })}
          replace
          to={{ pathname: '/withdraw', search: location.search }}
        >
          <MenuIconWithdraw />
          <div>Withdraw</div>
        </Link>
        <Link
          className={classNames(styles.item, {
            [styles.active]: location.pathname === '/recharge/record' || location.pathname === '/withdraw/record'
          })}
          replace
          to={getRecordLink()}
        >
          <MenuIconRecord />
          <div>History</div>
        </Link>
        <Link
          className={classNames(styles.item, {
            [styles.active]: location.pathname === '/vip'
          })}
          replace
          to={{ pathname: '/vip', search: location.search }}
        >
          <MenuIconVip />
          <div>VIP</div>
        </Link>
      </div>
      <Outlet />
    </>
  );
};

export default AmountMenu;
